// src/merch/StoreBrand.jsx — the store's logo (or wordmark) and the
// "Powered by MerchMod" credit, shared by every MerchMod page.

import React from "react";
import { STORE, IS_MERCHMOD, href } from "./stores";

export function StoreLogo({ link = null }) {
  const inner = STORE.logo
    ? <img className="ma-logo" src={STORE.logo} alt={STORE.name} />
    : <span className="ma-wordmark">{STORE.name}</span>;
  return link ? <a href={link} className="ma-logo-link">{inner}</a> : inner;
}

/** Small "Demo" chip next to the logo on merchmod.ca/demo. */
export function DemoChip() {
  if (!IS_MERCHMOD) return null;
  return <a className="ma-demo-chip" href={href("/")} title="What is MerchMod?">Demo</a>;
}

export function StoreFooter() {
  return (
    <footer className="ma-footer">
      <a href={href("/privacy")}>Privacy</a>
      {IS_MERCHMOD ? (
        <span>© MerchMod</span>
      ) : (
        <>
          <span>© {STORE.name}</span>
          <a className="ma-powered" href="https://merchmod.ca" target="_blank" rel="noreferrer">
            Powered by <b>MerchMod</b>
          </a>
        </>
      )}
    </footer>
  );
}
